import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CustomButton from "../Common/CustomButton";
import StatusDialog from "../Common/StatusDialog";
import CloseIcon from "../Common/CloseIcon";

import { success } from "../../constants/common";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";
import Loader from "../Common/Loader";

const styles = {
  dialogPaper1: {
    paddingTop: "24px",
    minWidth: "350px",
    maxWidth: "350px",
  },
  dialogPaper2: {
    paddingTop: "24px",
    minWidth: "750px",
    maxWidth: "750px",
  },
  closeBtn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  title: {
    textTransform: "uppercase",
    color: colors.black87,
    fontWeight: 500,
    textAlign: "center",
  },
};

const CreateDialog = (props) => {
  const { classes, level, validForm, values, status, reset, submit, isSubmitting } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <img
        src={images.plusIconColored}
        alt="plus_icon"
        onClick={() => setOpen(true)}
        style={{ cursor: "pointer", marginBottom: "-6px" }}
      />
      {status && open ? (
        <StatusDialog
          status={status}
          onClose={() => {
            setOpen(false);
            reset();
          }}
        >
          <div style={{ fontSize: "1.2em" }} className="text-87 text-center">
            <span>{I18n.get(`companies_${level}`)}</span>
            <span className="bold-500">{get(values, ["name"])}</span>
            <span>{` ${I18n.get(
              status === success
                ? "companies_createdSuccessfully"
                : "companies_creationFailed"
            )}.`}</span>
          </div>
        </StatusDialog>
      ) : (
        <Dialog
          open={open}
          classes={{
            paper:
              props.columns === 2 ? classes.dialogPaper2 : classes.dialogPaper1,
          }}
        >
          {isSubmitting ?
            <Loader height={250} noDecoration />
            :
            <Grid container direction="column">
              <Grid item style={{ padding: "0px 24px" }}>
                <Grid container alignItems="center">
                  <Grid item xs={2} />
                  <Grid item xs className="dialogTitle">aW
                    {I18n.get(`companies_${level}New`)}
                  </Grid>
                  <Grid item xs={2} className={classes.closeBtn}>
                    <CloseIcon closeFunction={() => setOpen(false)} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                style={{
                  padding: "0px 24px",
                  maxHeight: "calc(100vh - 212px)",
                  overflow: "auto",
                }}
              >
                {props.children}
              </Grid>
              <Grid item style={{ padding: "24px 0px" }}>
                <Grid container justify="center" alignItems="center">
                  <Grid item>
                    <CustomButton color="primary" onClick={() => setOpen(false)}>
                      {I18n.get("site_cancel")}
                    </CustomButton>
                  </Grid>
                  <Grid item style={{ marginLeft: "10px" }}>
                    <CustomButton
                      variant="contained"
                      color="primary"
                      disabled={!validForm}
                      onClick={submit}
                    >
                      {I18n.get("site_confirm")}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          }
        </Dialog>
      )}
    </>
  );
};

export default withStyles(styles)(CreateDialog);
